import { ISignUp } from 'src/app/interfaces/entryPoint';

// tslint:disable-next-line:no-namespace
export namespace AuthAction {
    export class MainLogin {
        static readonly type = '[Auth] MainLogin';
        constructor(public payload: { email: string; password: string; remember: boolean }) {}
    }

    export class PinLogin {
        static readonly type = '[Auth] PinLogin';
        constructor() {}
    }

    export class StaffMe {
        static readonly type = '[Auth] StaffMe';
        constructor() {}
    }

    export class MainLogout {
        static readonly type = '[Auth] MainLogout';
        constructor() {}
    }

    export class PinLogout {
        static readonly type = '[Auth] PinLogout';
        constructor() {}
    }

    export class SignUp {
        static readonly type = '[Auth] SignUp';
        constructor(public payload: ISignUp) {}
    }

    export class ForgotPassword {
        static readonly type = '[Auth] ForgotPassword';
        constructor(public payload?: { email: string }) {}
    }

    export class ForgotPin {
        static readonly type = '[Auth] ForgotPin';
        constructor() {}
    }

    export class ResetPassword {
        static readonly type = '[Auth] ResetPassword';
        constructor() {}
    }

    export class OrgTypes {
        static readonly type = '[Auth] OrgTypes';
        constructor() {}
    }

    export class FeedBack {
        static readonly type = '[Auth] FeedBack';
        constructor(public payload: any) {}
    }

    export class AddOrg {
        static readonly type = '[Auth] AddOrg';
        constructor(public payload: any) {}
    }
}
